import api from 'api';
import makeSorter from 'lib/makeSorter';
import { regexpSearch } from 'lib/searchFns';
import ___ from '../constants';
import { result } from 'lodash';
import { matchesExactFields, matchesIncludeFields, subtractFields } from '../shared/searchUtilites';
import Cookies from 'js-cookie';

const dateColumns = [
    'est_arrival_date',
]

const initialState = {
    currentEditRow: null,
    currentEditHeader: null,
    originalEditRow: null,
    detailLines: null,
    originalOrders: [],
    filteredOrders: [],
    loading: false,
    sendingTo: false,
    searchLoading: false,
    currentDataSource: [],
    modalType: null,
    columns: [],
    filteredSource: [],
    searchedSource: [],
    sortOrder: false,
    sortField: false,
    sorting: [],
    filters: [],
    requestedPage: 0,
    forceReload: false,
    //warehousePerson: '',
    logged_in_rep: '',
    filterValues: {
        order_date_formatted: null,
        event_date: null,
        status: null,
    },
    warehouseOptions: [],
};

export const types = {
    SET_STATE: 'INCOMING/SET_STATE',
    SET_FILTER_VALUES: 'INCOMING/SETFILTERVALUES',
    START_LOADING: 'INCOMING/START_LOADING',
    CHANGE_FILTERS: 'INCOMING/CHANGE_FILTERS',
};

export const reducers = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_STATE:
            // DEBUG console.log('[Reducer] SET_STATE:', action.data);
            return { ...state, ...action.data };

        case types.SET_FILTER_VALUES:
            return {
                ...state,
                filterValues: {
                    ...state.filterValues,
                    ...action.data,
                },
            };

        case types.START_LOADING:
            return {
                ...state,
                requestedPage: action.data.requestedPage,
                take: action.data.take,
            };

        case types.CHANGE_FILTERS:
            return {
                ...state,
                forceReload: true,
                requestedSkip: 0,
                allOrders: [],
                filters: action.data.filters,
            };


        default:
            return state;
    }
};




export const actions = {
    setState: (data) => ({ type: types.SET_STATE, data }),

    setFilterValues: (data) => ({ type: types.SET_FILTER_VALUES, data }),

    startLoading: (data) => ({ type: types.START_LOADING, data }),

    setCurrentEditRow: (row) => async (dispatch, getState) => {
        //console.log('[Incoming.redux.js] setCurrentEditRow');
        //console.log(row);
        dispatch({
            type: types.SET_STATE,
            data: {
                currentEditRow: row,
            },
        });
    },

    getIncoming: () => async (dispatch, getState) => {
        console.log('[Incoming.redux.js] getIncoming()');
        const state = getState();
        let LastSystem = Cookies.get('LastSystem');
        
        dispatch(actions.setState({ loading: true }));

        try {
            console.log('selectedSystem', state.auth.selectedSystem);

            // QUERY Warehouse.GetInbound
            let result = await api.get('/warehouse/receiving', {
                params: {
                    system: state.auth.selectedSystem ?? LastSystem // 'NO_SYS'
                }
            });
            //console.log(result)
            //console.log(result.incomingOrders.recordset)
            let _result = result.incomingOrders.recordset;
            //console.log(typeof _result)
            // console.log(typeof _result[0])

            const _arrayResult = [];
            for (let [key, value] of Object.entries(_result)) {
                //console.log(key, value);
                _arrayResult.push(value)
            }
            //console.log(_arrayResult)
            //console.log(typeof _arrayResult)

            dispatch(actions.setState({
                // incomingOrders: [..._obj],
                // currentDataSource: [..._obj],
                // filteredSource: [..._obj],
                originalOrders: _arrayResult,
                filteredOrders: _arrayResult,
                currentDataSource: _arrayResult,
                filteredSource: _arrayResult,
                loading: false
            }));
        } catch (err) {
            console.log('getIncoming catch err')
            console.error(err);
            dispatch(actions.setState({
                originalOrders: [],
                filteredOrders: [],
                currentDataSource: [],
                filteredSource: [],
                loading: false
            }));
        }
    },

    searchCurrent: ({ searchValue = '', excludeList = [], includeList = [], exactList = [] }) => (dispatch, getState) => {
        console.log('[Incoming.redux] searchCurrent');

        const finalIncludeList = subtractFields(includeList, excludeList, exactList);
        const finalExactList = exactList.filter(field => !excludeList.includes(field));

        dispatch(actions.setState({ searchLoading: true }));

        setTimeout(() => {
            const { filteredSource, sortOrder, sortField } = getState().warehouse;
            let searchedSource = [];

            for (let bp of filteredSource) {
                if (searchValue === '') {
                    searchedSource.push(bp);
                    continue;
                }

                const matchedInclude = matchesIncludeFields(bp, finalIncludeList, searchValue);
                const matchedExact = matchesExactFields(bp, finalExactList, searchValue);

                if (matchedInclude || matchedExact) {
                    searchedSource.push(bp);
                }
            }

            dispatch(actions.setState({
                searchedSource: [...searchedSource],
                searchValue,
                hasFilterBeenApplied: true,
                hasOrder: true,
            }));

            dispatch(actions.sortCurrent({
                field: sortField,
                order: sortOrder
            }));

            dispatch(actions.setState({ searchLoading: false }));
        }, 1000); // 1 second delay
    },

    sortCurrent: ({ field, order }) => (dispatch, getState) => {
        //console.log('[Incoming.redux] sortCurrent ')
        //console.log(field)
        //console.log(order)
        let { searchedSource, columns } = getState().warehouse;

        const numberSortColumns = [
            ...dateColumns,
            'card_code',
        ];

        let newColumns = columns.map((col) => {
            if (col.dataIndex === field) {
                return { ...col, sortOrder: order }
            } else {
                return { ...col, sortOrder: false }
            }
        });

        let incomingOrders = searchedSource; // IMPORTANT

        if (field !== false) {
            let type = 'string';
            if (numberSortColumns.indexOf(field) !== -1) {
                type = 'number';
            }
            incomingOrders = searchedSource.sort(makeSorter(type, field));
        }

        if (order === 'ascend') {
            incomingOrders = incomingOrders.reverse();
        }

        dispatch(actions.setState({
            columns: newColumns,
            filteredOrders: [...incomingOrders],
            sortOrder: order,
            sortField: field,
        }));
    },

    getIncomingPODetails: () => async (dispatch, getState) => {
        console.log('[Incoming.redux.js] getIncomingPODetails()');
        const state = getState().warehouse;
        dispatch(actions.setState({ loading: true }));

        //console.log(state.currentEditRow)
        //console.log(state.currentEditRow.docKey)
        //console.log(state.currentEditRow.docEntry)
        //console.log(typeof state.currentEditRow.docKey)

        try {
            // QUERY Warehouse.GetPurchaseOrderLines
            let result = await api.get(`/warehouse/receiving/po-details/${state.currentEditRow.docEntry}`, {
                params: {
                    docKey: state.currentEditRow.docKey
                }
            });
            //console.log(result)
            console.log(result.detailLines.recordset)
            dispatch(actions.setState({ detailLines: result.detailLines.recordset, modalType: ___.PURCHASE_ORDER }));
        } catch (err) {
            console.error(err);
        }
        dispatch(actions.setState({ loading: false }));
    },

    getIncomingPROSODetails: () => async (dispatch, getState) => {
        console.log('[Incoming.redux.js] getIncomingPROSODetails()')
        const state = getState().warehouse;
        dispatch(actions.setState({ loading: true }));
        //console.log(state.currentEditRow)
        //console.log(state.currentEditRow.docKey)
        //console.log(state.currentEditRow.docEntry)
        //console.log(typeof state.currentEditRow.docKey)

        try {
            // QUERY Warehouse.GetPROFinishedGood
            let result = await api.get(`/warehouse/receiving/pro-so-details/${state.currentEditRow.docEntry}`, {
                params: {
                    docKey: state.currentEditRow.docKey,
                },
            });
            //console.log(result)
            console.log(result.detailLines.recordset)
            dispatch(actions.setState({ detailLines: result.detailLines.recordset, modalType: ___.PRODUCTION_ORDER }));
        } catch (err) {
            console.error(err);
        }
        dispatch(actions.setState({ loading: false }));
    },

    writeProductionOrder: (currentEditRow, editDetailsLines, popSuccessCB) => async (dispatch, getState) => {
        console.log('[Incoming.redux.js] writeProductionOrder()');
        console.log('editDetailsLines', editDetailsLines);
        const state = getState().warehouse;
        //const { currentEditRow } = state;
        console.log(currentEditRow);

        dispatch(actions.setState({ loading: true }));

        try {
            let _filtered = editDetailsLines.filter((r) => (r.orderQty && r.orderQty > 0));
            //console.log(_filtered);
            let result = await api.put('/warehouse/write-goods-receipt-pro', // TODO default warehouse
                {
                    BaseDocEntry: currentEditRow.docEntry,
                    BaseDocType: 202, // OR currentEditRow.objType
                    Qty: currentEditRow.orderQty,
                    Comments: currentEditRow.notes,
                    selectedWarehouse: currentEditRow.selectedWarehouse,
                    submitRows: _filtered, // not used yet
                });
            console.log(result);
            //console.log(result.data);

            console.log(result.success);
            if (result.success) {
                console.log('success');
                popSuccessCB();
                dispatch(actions.getIncoming());
            }

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write');
            console.error(err);
            dispatch(actions.setState({ loading: false }));
        }
    },

    writePurchaseOrder: (currentEditRow, editDetailsLines, popSuccessCB) => async (dispatch, getState) => {
        console.log('[Incoming.redux.js] writePurchaseOrder()');
        //console.log(currentEditRow);
        //console.log(editDetailsLines);

        const state = getState().warehouse;
        dispatch(actions.setState({ loading: true }));

        let _filtered = editDetailsLines.filter((r) => (r.orderQty && r.orderQty > 0));
        //console.log(_filtered);

        let sendBody = {
            BaseDocEntry: currentEditRow.docEntry,
            BaseDocType: 22, // OR currentEditRow.objType
            CardCode: currentEditRow.cardCode,
            submitRows: _filtered,
        };

        // TODO_BLANK_NOTES need to prevent writing comments if they are blank, except when they would be intentionally blank
        if (currentEditRow.notes && currentEditRow.notes !== '') {
            sendBody.Comments = currentEditRow.notes;
        }

        try {
            let result = await api.put('/warehouse/write-grpo', // TODO default warehouse
                sendBody);
            console.log(result);

            //console.log(result.success);
            if (result.success) {
                console.log('success');
                popSuccessCB();
                dispatch(actions.getIncoming());
                //dispatch(actions.setState({ purchaseOrders: result.purchaseOrders.recordset }));
            }

            //console.log(result.errorMsg); // errorMsg: "One of the base documents has already been closed"

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write');
            console.error(err);
            dispatch(actions.setState({ loading: false }));
        }
    },
    get_warehouse_options: () => async (dispatch) => {
        console.log('[Incoming.redux.js] get_warehouse_options');
        // TODO we could probably consolidate the three routes/queries into one, but we didnt know where the default warehouse was supposed to come from at the time, so we made separate routes/queries for each.
        dispatch(actions.setState({ loading: true }));

        api.get('/warehouse/get-warehouse-options-po/').then(res => {
            let warehouseOptions = res.options;

            dispatch(actions.setState({ warehouseOptions }));
            dispatch(actions.setState({ loading: false }));
        }).catch(err => {
            console.error(err);
            dispatch(actions.setState({ loading: false }));
        });

    },

    writeSalesOrderNotes: (currentEditRow) => async (dispatch, getState) => {
        console.log('[Incoming.redux.js] writeSalesOrderNotes()');
        console.log(currentEditRow);

        const state = getState().warehouse;

        dispatch(actions.setState({ loading: true }));

        let sendBody = {
            SODocEntry: currentEditRow.SODocEntry,
            orderNotes: currentEditRow.orderNotes,
            internalNotes: currentEditRow.internalNotes,
        };

        try {
            let result = await api.put('/warehouse/write-so-notes',
                sendBody);

            if (result.success) {
                console.log('success');
                // stitch the notes back into the current rows and detail rows
                const updatedOrders = state.filteredOrders.map(order => {
                    if (order.docEntry === currentEditRow.docEntry) {
                        return { ...order, ...currentEditRow };
                    }
                    return order;
                });
                dispatch(actions.setState({
                    filteredOrders: updatedOrders,
                    currentEditRow: currentEditRow,
                    loading: false
                }));
            }

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write notes');
            console.error(err);
            dispatch(actions.setState({ loading: false }));
        }
    },
    writeSalesSendTo: (currentEditRow, sendToValue) => async (dispatch, getState) => {
        console.log('[Incoming.redux.js] writeSalesSendTo()');
        console.log(currentEditRow);
        console.log(sendToValue);

        const state = getState().warehouse;

        dispatch(actions.setState({ sendingTo: true }));

        let sendBody = {
            SODocEntry: currentEditRow.SODocEntry,
            sendTo: sendToValue,
        };

        try {
            let result = await api.put('/warehouse/write-so-send-to',
                sendBody);

            if (result.success) {
                console.log('success');
                dispatch(actions.setState({
                    sendingTo: false
                }));
            }

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write Send To');
            console.error(err);
            dispatch(actions.setState({ sendingTo: false }));
        }
    },
};
